import { createContext } from 'react';
import { UiTheme } from 'src/config/constants';
import { MultiUiBrandContextType } from './type';

const MultiUiBrandContext = createContext<MultiUiBrandContextType>({
  uiBrand: UiTheme.hpsmart
});

export default MultiUiBrandContext;
